// extracted by mini-css-extract-plugin
export default {"cellGrid":"AvailabilityPrice-cellGrid_Sk0Se"};